/* eslint-disable import/prefer-default-export */
import { defineStore } from "pinia";
import axios from "axios";
import { useSnackbarHandler } from "@/composables/useSnackbarHandler";
export const useRateGroupStore = defineStore("rateGroupStore", {
  state: () => {
    const {
      handleError,
      handleSuccess
    } = useSnackbarHandler();
    return {
      saving: false,
      // Defaults to Vue's snackbar handler so pure-Vue consumers (e.g.
      // BulkActionBar.vue) work out of the box; AngularJS-bridged pages
      // still override this with rateGroupStore.alerts = props.alerts.
      alerts: {
        error: message => {
          if (message && typeof message === "object" && (message.response || message.message)) {
            handleError(message);
          } else {
            handleError(new Error(message || "An error occurred"));
          }
        },
        success: message => handleSuccess(message)
      },
      rateGroupList: [],
      rateGroupMatters: []
    };
  },
  actions: {
    async listRateGroup() {
      try {
        const params = `format=settings`;
        const response = await axios({
          url: `rateGroups?${params}`
        });
        this.$patch({
          rateGroupList: response.data
        });
        return response.data;
      } catch (error) {
        this.alerts.error(error.response?.data?.message || error.message);
      }
    },
    async getRateGroup(rateGroupId) {
      try {
        if (!rateGroupId) return;
        const response = await axios({
          url: `rategroups/${rateGroupId}`
        });
        return response.data;
      } catch (error) {
        this.alerts.error(error.response?.data?.message || error.message);
      }
    },
    async createRateGroup(rateGroup) {
      try {
        const response = await axios({
          url: "rategroups",
          method: "POST",
          data: rateGroup
        });
        this.rateGroupList.push(response.data);
        this.alerts.success("Rate Group Created Successfully!");
      } catch (error) {
        this.alerts.error(error.response?.data?.message || error.message);
      }
    },
    async updateRateGroup(id, updatedRateGroup) {
      try {
        const response = await axios({
          url: `rategroups/${id}`,
          method: "PUT",
          data: updatedRateGroup
        });
        const index = this.rateGroupList.findIndex(rateGroup => rateGroup.rateGroupId === id);
        if (index !== -1) {
          this.rateGroupList.splice(index, 1, response.data);
        }
        this.alerts.success("Rate Group Updated Successfully!");
      } catch (error) {
        this.alerts.error(error.response?.data?.message || error.message);
      }
    },
    async duplicateRateGroup(rateGroupId) {
      try {
        const response = await axios({
          url: `rategroups/${rateGroupId}/duplicate`,
          method: "POST"
        });
        this.rateGroupList.push(response.data);
        this.alerts.success("Rate Group Duplicated Successfully!");
      } catch (error) {
        this.alerts.error(error.response?.data?.message || error.message);
      }
    },
    async deleteRateGroup(rateGroupId) {
      try {
        await axios({
          url: `rategroups/${rateGroupId}`,
          method: "DELETE"
        });
        const index = this.rateGroupList.findIndex(rateGroup => rateGroup.rateGroupId === rateGroupId);
        if (index !== -1) {
          this.rateGroupList.splice(index, 1);
        }
        this.alerts.success("Rate Group Deleted Successfully!");
      } catch (error) {
        this.alerts.error(error.response?.data?.message || error.message);
      }
    },
    async loadGroupMatters(id) {
      try {
        const response = await axios({
          url: `rategroups/${id}/matters`
        });
        this.$patch({
          rateGroupMatters: response.data
        });
        return response.data;
      } catch (error) {
        this.alerts.error(error.response?.data?.message || error.message);
      }
    },
    async rateGroupStatusToggle() {
      try {
        const response = await axios({
          url: "rateGroups/enable",
          method: "POST"
        });
        return response.data;
      } catch (error) {
        this.alerts.error(error.response?.data?.message || error.message);
      }
    }
  }
});